import { Form, Select } from "antd";
import { debounce } from "lodash";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";


interface SelectAudienceListProps {
  errors: any;
  value: string;
  isCampaignExist: boolean;
  showLabel?: boolean;
  styles?: React.CSSProperties
  onChange: (value: string) => void;
  loadMoreLeadLists: (params: any) => void;
}

export const SelectAudienceList = ({ errors, value, onChange, loadMoreLeadLists, isCampaignExist, showLabel = true, styles }: SelectAudienceListProps) => {
  const { leadLists, leadListsLoading, leadListsMetaData: { has_next } } = useSelector((state: any) => state.leads);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (!isCampaignExist) {
      loadMoreLeadLists({
        page: 1,
      });
      setCurrentPage(1);
    } else {
      loadMoreLeadLists({
        id: value,
      });
    }
  }, []);

  const onSearch = debounce((value: string) => {
    setSearchTerm(value);
    setCurrentPage(1);
    loadMoreLeadLists({
      page: 1,
      search: value,
    });
  }, 1000);

  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    const scrollElement = target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = scrollElement;
    const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isBottom && has_next && !leadListsLoading) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      loadMoreLeadLists({
        page: nextPage,
        search: searchTerm,
      });
    }
  };

  const handleChange = (value: string) => {
    onChange(value);
  };

  const options = leadLists.map((list: any) => ({
    label: list.list_name,
    value: list.id,
  }));

  return (
    <Form.Item name="audience_list_id"
      style={styles}
      {...(showLabel && { validateStatus: errors.audience_list_id ? 'error' : '', help: errors.audience_list_id ? errors.audience_list_id?.toString() : '', label: 'Audience List*:' })}
    >
      <Select
        placeholder="Select an audience list"
        disabled={isCampaignExist}
        defaultValue={value}
        value={value}
        onChange={handleChange}
        optionLabelProp="label"
        // showSearch
        // onSearch={onSearch}
        loading={leadListsLoading}
        onPopupScroll={handlePopupScroll}
        options={options}
      />
    </Form.Item>
  )
};